"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EMCMLoginServiceConfiguration = _interopRequireDefault(require("./EMCMLoginServiceConfiguration"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _default = /*#__PURE__*/function (_EMCMLoginServiceConf) {
  _inherits(_default, _EMCMLoginServiceConf);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this);
    _this.emcm.authPageLocation = "https://tax-tr-com-ppe-ams.ewp.thomsonreuters.com/auth";
    _this.emcm.location = "/bin/ewp";
    _this.estore.location = "https://store.tax.thomsonreuters.com/accounting";
    _this.identityService.clientId = "trtaewp-ppe";
    _this.identityService.location = "https://mytr-id-nonprod-identity-int.thomsonreuters.com";
    _this.onepass.location = "https://signon.qa.thomsonreuters.com/v2";
    _this.onepass.productId = "MKTTAXEWP";

    _this.transferIframeLocations.push("https://store.tax.thomsonreuters.com/accounting/login?transfertoken=");

    _this.transferIframeLocations.push("https://site.tax.thomsonreuters.com/federatedSSO.php?transfertoken=");

    _this.signoutIframeLocations.push("https://store.tax.thomsonreuters.com/accounting/logout");

    _this.signoutIframeLocations.push("https://site.tax.thomsonreuters.com/?signout=true");

    return _this;
  }

  return _default;
}(_EMCMLoginServiceConfiguration["default"]);

exports["default"] = _default;